import React from "react";
import { NavLink } from "react-router-dom";
import { Icon, Logo } from "ui/components/atoms";
import { useSessionContext } from "ui/context/SessionContext";
import styles from "./HamburgerMenu.module.scss";

const HamburgerMenu: React.FC = () => {
    const sessionContext = useSessionContext();
    const [active, setActive] = React.useState<boolean>(false);

    return (
        <nav className={styles.navigation}>
            <div className={styles.navigation__header}>
                <div className={styles.navigation__header__logo}>
                    <Logo />
                </div>
                <div
                    role="presentation"
                    onClick={() => {
                        setActive(!active);
                    }}
                    className={styles.navigation__header__icon__container}
                >
                    <Icon
                        className={styles.navigation__header__icon}
                        name={active ? "close" : "reorder"}
                    />
                </div>
                <div
                    className={active ? styles.sidenav__active : styles.sidenav}
                >
                    <ul className={styles.navigation__menu}>
                        {sessionContext.userHasMultipleProjects && (
                            <div className={styles.navigation__menu__item}>
                                <NavLink
                                    className={
                                        styles.navigation__menu__item__link
                                    }
                                    to="/projects"
                                >
                                    <Icon
                                        className={
                                            styles.navigation__menu__item__icon
                                        }
                                        name="switch"
                                    />
                                    <span
                                        className={
                                            styles.navigation__menu__item__text
                                        }
                                    >
                                        Change project
                                    </span>
                                </NavLink>
                            </div>
                        )}
                        <div className={styles.navigation__menu__item}>
                            <NavLink
                                className={styles.navigation__menu__item__link}
                                to="settings"
                            >
                                <Icon
                                    className={
                                        styles.navigation__menu__item__icon
                                    }
                                    name="user"
                                />
                                <span
                                    className={
                                        styles.navigation__menu__item__text
                                    }
                                >
                                    Profile
                                </span>
                            </NavLink>
                        </div>
                        <div className={styles.navigation__menu__item}>
                            <NavLink
                                className={styles.navigation__menu__item__link}
                                to="/support"
                            >
                                <Icon
                                    className={
                                        styles.navigation__menu__item__icon
                                    }
                                    name="settings"
                                />
                                <span
                                    className={
                                        styles.navigation__menu__item__text
                                    }
                                >
                                    Support
                                </span>
                            </NavLink>
                        </div>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default HamburgerMenu;
